
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"23.543","height":"20.695"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 7299","transform":"translate(.75)","fill":"none","stroke":"#74ce00","stroke-miterlimit":"10","stroke-width":"1.5"}},[_c('rect',{attrs:{"data-name":"Rectangle 2898","width":"22.042","height":"17.844","rx":"2","transform":"translate(0 2.101)"}}),_c('g',{attrs:{"data-name":"Group 5571"}},[_c('path',{attrs:{"data-name":"Line 1","d":"M3.6 0v4"}}),_c('path',{attrs:{"data-name":"Line 54","d":"M10.799 0v4"}}),_c('path',{attrs:{"data-name":"Line 2","d":"M17.999 0v4"}})]),_c('g',{attrs:{"data-name":"Group 5572"}},[_c('path',{attrs:{"data-name":"Line 61","d":"M3.674 11.912h1.841"}}),_c('path',{attrs:{"data-name":"Line 65","d":"M3.674 15.746h1.841"}}),_c('path',{attrs:{"data-name":"Line 55","d":"M7.873 8.079h1.841"}}),_c('path',{attrs:{"data-name":"Line 60","d":"M7.873 11.912h1.841"}}),_c('path',{attrs:{"data-name":"Line 64","d":"M7.873 15.746h1.841"}}),_c('path',{attrs:{"data-name":"Line 56","d":"M12.071 8.079h1.841"}}),_c('path',{attrs:{"data-name":"Line 58","d":"M12.071 11.912h1.841"}}),_c('path',{attrs:{"data-name":"Line 62","d":"M12.071 15.746h1.841"}}),_c('path',{attrs:{"data-name":"Line 57","d":"M16.27 8.079h1.841"}}),_c('path',{attrs:{"data-name":"Line 59","d":"M16.27 11.912h1.841"}})])])])
          )
        }
      }
    